import { Api } from "@/config";
import Invoice from "@/models/invoice";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { SET_INVOICES } from "@/store/mutation-types";

@Module({ namespaced: true })
export default class Invoices extends VuexModule {
  invoices: Array<Invoice> = [];

  //#region Actions
  @Action
  public get(): Promise<void> {
    return new Promise((resolve, reject) => {
      Api.get(`invoices`).then(
        (response) => {
          if (response && response.status === 200) {
            let invoices: Array<Invoice> = [];

            response.data.forEach((invoice: any) => {
              invoices.push(new Invoice(invoice));
            });

            this.context.commit(SET_INVOICES, invoices);
          }

          resolve();
        },
        (error) => {
          reject(error.response);
        }
      );
    });
  }
  //#endregion

  //#region Mutations
  @Mutation
  public [SET_INVOICES](invoices: Array<Invoice>) {
    this.invoices = invoices;
  }
  //#endregion
}
